
import { displayDateByString } from '../../../../utils/globals/date'
import { TwinDictionary } from '../../../../utils/globals/dictionary'
import { BuyModelTypeExtended, OnChangeSearchBarAddBuySupplier } from '../types'

interface SearchBarBuySupplierResultsProps {
    buys: BuyModelTypeExtended[] | null
    onSelectBuy: OnChangeSearchBarAddBuySupplier
    className?: string
}

const SearchBarBuySupplierResults: React.FC<SearchBarBuySupplierResultsProps> = ({ buys, onSelectBuy, className }) => {
    const renderThis: JSX.Element[] = []
    if (!buys) {
        return null
    }
    for (const key in buys) {
        const buy = buys[key]
        renderThis.push(<SearchedBuySupplier key={key} buy={buy} onSelectBuy={onSelectBuy} />)
    }
    return (
        <div className={'searched_input_products ' + (className || '')}>
            <div className='results_searched_products'>
                {renderThis}
            </div>
        </div>
    )
}

interface SearchedBuySupplierProps {
    onSelectBuy: OnChangeSearchBarAddBuySupplier
    buy: BuyModelTypeExtended
}

const SearchedBuySupplier: React.FC<SearchedBuySupplierProps> = ({ buy, onSelectBuy }) => {
    const supplierName = buy?.Supplier?.name
    const reference = buy.full_assigned_number
    const workingCenterName = buy.BillingWorkingCenter?.name
    const date = displayDateByString(buy.processed_date || buy.createdAt)
    let fields: TwinDictionary = {
        main: supplierName,
        secondary: reference,
        date: date
    }
    return (
        <div className='searched_product' onClick={() => onSelectBuy(buy)}>
            <span className='text-green-00 font-medium'>{fields.secondary}</span>
            <span className='mx-5'>-</span>
            <span className='twin_elipsis'>{fields.main}</span>
            <span className='mx-5'>-</span>
            <span>{fields.date}</span>
            <span className='mx-5'>-</span>
            <span className='twin_elipsis'>{workingCenterName}</span>
        </div>
    )
}

export default SearchBarBuySupplierResults